<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChanged($event)"
  position="right"
  [style]="{ width: 'min(520px, 100vw)', height: '100dvh', maxHeight: '100dvh', margin: '0' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="fas-drawer"
  [header]="'FLEXI_SETTINGS.EDIT_TITLE' | translate"
>
  <div class="fae">
    <p class="fas-muted fae-business">
      <strong>{{ business.CompanyName }}</strong>
      · {{ 'FLEXI_SETTINGS.ORG' | translate: { org: business.OrganizationNumber || '–' } }}
    </p>

    <section class="fae-section">
      <h4 class="fae-heading">{{ 'FLEXI_SETTINGS.PRIORITY' | translate }}</h4>
      <p class="fas-muted">{{ 'FLEXI_SETTINGS.PRIORITY_HINT' | translate }}</p>

      <ol class="fae-list" *ngIf="advisors.length; else noAdvisors">
        <li
          *ngFor="let advisor of advisors; let i = index; let last = last"
          class="fae-item"
          [class.fae-item--primary]="advisor.IsPrimary"
          [class.fae-item--inactive]="!advisor.IsEligible"
        >
          <span class="fas-advisor__pos">{{ i + 1 }}</span>
          <span class="fas-avatar" [class.fas-avatar--inactive]="!advisor.IsEligible" aria-hidden="true">{{ initials(advisor.Name) }}</span>
          <span class="fae-item__text">
            <strong>{{ advisor.Name }}</strong>
            <span class="fas-muted">{{ advisor.Email }}</span>
          </span>
          <span class="fas-badge fas-badge--primary" *ngIf="advisor.IsPrimary">{{ 'FLEXI_SETTINGS.PRIMARY' | translate }}</span>
          <span class="fas-badge fas-badge--inactive" *ngIf="!advisor.IsEligible">{{ 'FLEXI_SETTINGS.SKIPPED' | translate }}</span>
          <span class="fae-item__actions">
            <button
              type="button"
              class="fas-icon-btn"
              [disabled]="i === 0"
              [attr.aria-label]="'FLEXI_SETTINGS.MOVE_UP' | translate"
              (click)="moveUp(i)"
            >
              <i class="pi pi-arrow-up" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="fas-icon-btn"
              [disabled]="last"
              [attr.aria-label]="'FLEXI_SETTINGS.MOVE_DOWN' | translate"
              (click)="moveDown(i)"
            >
              <i class="pi pi-arrow-down" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="fas-icon-btn"
              [attr.aria-label]="'FLEXI_SETTINGS.REMOVE' | translate"
              (click)="remove(i)"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </span>
        </li>
      </ol>
      <ng-template #noAdvisors>
        <p class="fae-empty">{{ 'FLEXI_SETTINGS.NO_ADVISORS_PREVIEW' | translate }}</p>
      </ng-template>
    </section>

    <section class="fae-section">
      <label class="fae-heading" for="fae-add-advisor">{{ 'FLEXI_SETTINGS.ADD_ADVISOR' | translate }}</label>
      <div class="fae-add">
        <p-select
          inputId="fae-add-advisor"
          class="fae-add__select"
          [options]="addOptions"
          [(ngModel)]="toAdd"
          [filter]="true"
          appendTo="body"
          [placeholder]="'FLEXI_SETTINGS.SELECT_ADVISOR' | translate"
        ></p-select>
        <button type="button" class="fas-btn fas-btn--ghost" [disabled]="toAdd === null" (click)="add()">
          {{ 'FLEXI_SETTINGS.ADD' | translate }}
        </button>
      </div>
      <p class="fas-muted">{{ 'FLEXI_SETTINGS.ADD_HINT' | translate }}</p>
    </section>

    <section class="fae-section">
      <h4 class="fae-heading">{{ 'FLEXI_SETTINGS.PREVIEW' | translate }}</h4>
      <div class="fae-preview" *ngIf="primary as shown; else noPrimary">
        <span class="fas-avatar" aria-hidden="true">{{ initials(shown.Name) }}</span>
        <span class="fae-item__text">
          <span class="fas-muted">{{ 'FLEXI_SETTINGS.YOUR_ADVISOR' | translate }}</span>
          <strong>{{ shown.Name }}</strong>
          <span class="fas-muted">{{ shown.Email }}</span>
        </span>
      </div>
      <ng-template #noPrimary>
        <p class="fae-empty">{{ 'FLEXI_SETTINGS.PREVIEW_EMPTY' | translate }}</p>
      </ng-template>
    </section>

    <p class="fas-note">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ 'FLEXI_SETTINGS.EDIT_ACCESS_NOTE' | translate }}</span>
    </p>

    <p class="fas-error" *ngIf="saveFailed" role="alert">{{ 'FLEXI_SETTINGS.SAVE_FAILED' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="fas-dialog-actions">
      <button type="button" class="fas-btn fas-btn--ghost" (click)="cancel()">
        {{ 'FLEXI_SETTINGS.CANCEL' | translate }}
      </button>
      <button type="button" class="fas-btn fas-btn--primary" [disabled]="!dirty || saving" (click)="save()">
        <i class="pi pi-spin pi-spinner" *ngIf="saving" aria-hidden="true"></i>
        {{ 'FLEXI_SETTINGS.SAVE' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>
